export default "__VITE_ASSET__DicoRfFP__"